import React, { createContext, useContext, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999; /* High z-index to ensure it overlays other content */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

export const Loader = () => {
  return (
    <Container className="shimmer-wrapper">
      <img
        src="/bravo-circle-logo.png"
        alt="Loading..."
        style={{
          width: "200px",
          height: "200px",
        }}
      />
    </Container>
  );
};

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
